export const baseURL = process.env.REACT_APP_API_URL;
// export const baseURL = "http://192.168.29.104:8000/";
export const socketURL = "http://192.168.1.9:8000";

export const ApiURL = {
  //*********************************** Auth ****************************************** //

  login: "/api/login-post/",
  logout: "/api/logout-view/",
  sinup: "/api/sign-up-with-company/",
  send_registration_otp: "/api/send-registration-otp/",
  registration_otp_verification: "/api/registration-otp-verification/",
  resent_otp: "/api/resent-otp/",
  password_reset: "/api/password-reset/",
  forgot_view: "/api/forgot-view/",

  //*********************************** Staff ****************************************** //

  staff_Ship_View: "/staff-api/view-ship-main-details/",
  staff_dashboard: "/staff-api/staff-dashboard/",
  add_engine_logbook: "/staff-api/add-engine-logbook/",
  listing_engine_logbook: "/staff-api/listing-engine-logbook/",
  view_eng_logbook: "/staff-api/view-eng-logbook/",
  list_deck_logs: "/staff-api/list-deck-logs/",
  create_deck_log: "/staff-api/create-deck-log/",
  delete_deck_log: "/staff-api/delete-deck-log/",
  view_or_update_deck_log: "/staff-api/view-or-update-deck-log/",
  list_tanks_by_ship: "/staff-api/list-tanks-by-ship/",
  list_tank_updates_sound_log_book:
    "/staff-api/list-tank-updates-sound-log-book/",
  list_sound_log_books: "/staff-api/list-sound-log-books/",
  list_ships_view: "/staff-api/list-ships-view/",
  list_voyage_info: "/staff-api/list-voyage-info/",
  view_voyage_info: "/staff-api/view-voyage-info/",
  edit_voyage_info: "/staff-api/edit-voyage-info/",
  add_voyage_info: "/staff-api/add-voyage-info/",
  delete_voyage_info: "/staff-api/delete-voyage-info/",
  update_tank_rob_and_comment: "/staff-api/update-tank-rob-and-comment/",
  garbage_record_details: "/staff-api/garbage-record-details/",
  add_garbage_details_st: "/staff-api/add-garbage-details/",
  list_garbage_records: "/staff-api/list-garbage-records/",
  add_eng_log_basic_st: "/staff-api/add-eng-log-basic/",
  view_update_eng_log_basic_st: "/staff-api/view-update-eng-log-basic/",
  add_main_eng_log_st: "/staff-api/add-main-eng-log/",
  view_update_main_eng_log_st: "/staff-api/view-update-main-eng-log/",
  add_auxiliary_eng_log_st: "/staff-api/add-auxiliary-eng-log/",
  view_update_auxiliary_eng_log_st: "/staff-api/view-update-auxiliary-eng-log/",
  add_auxiliary_machinery_fresh_water: "/staff-api/add-fresh-water/",
  add_auxiliary_machinery_air_conditioning: "/staff-api/add-air-conditiong/",
  add_auxiliary_machinery_refrigeration: "/staff-api/add-refrigeration/",
  add_auxiliary_other_machinery: "/staff-api/add-other-machine/",
  add_caargo_machinery_igg_st: "/staff-api/add-cargo-igg/",
  view_update_cargo_machinery_igg_st: "/staff-api/view-update-cargo-igg/",
  cargo_machinery_igg_list_st: "/staff-api/list-igg-parameters/",
  add_cargo_machinery_cran_st: "/staff-api/add-crane-cargo/",
  list_cargo_machinery_cran_st: "/staff-api/list-crane-parameters/",
  view_update_cargo_machinery_cran_st: "/staff-api/view-update-crane-cargo/",
  add_cargo_machinery_bwts_st: "/staff-api/add-bwt-cargo/",
  list_cargo_machinery_bwts_st: "/staff-api/list-bwts-machinery/",
  view_update_cargo_machinery_bwts_st: "/staff-api/view-update-bwt-cargo/",
  add_cargo_machinery_lpg_st: "/staff-api/add-lpg-cargo/",
  list_cargo_machinery_lpg_st: "/staff-api/list-lpg-cargo-parameters/",
  view_update_cargo_machinery_lpg_st: "/staff-api/view-update-lpg-cargo/",
  add_cargo_machinery_lng_st: "/staff-api/add-lng-cargo/",
  list_cargo_machinery_lng_st: "/staff-api/list-lng-cargo-parameters/",
  view_update_cargo_machinery_lng_st: "/staff-api/view-update-lng-cargo/",
  add_cargo_machinery_nitrogen_plant_st: "/staff-api/add-nitrogen-plant/",
  list_cargo_machinery_nitrogen_plant_st:
    "/staff-api/list-nitrogen-plant-parameters/",
  view_update_cargo_machinery_nitrogen_plant_st:
    "/staff-api/view-update-nitrogen-plant/",
  add_cargo_machinery_copt_st: "/staff-api/add-copt-cargo/",
  list_cargo_machinery_copt_st: "/staff-api/list-copt-parameters/",
  view_update_cargo_machinery_copt_st: "/staff-api/view-update-copt-cargo/",
  add_cargo_machinery_framo_st: "/staff-api/add-framo-cargo/",
  list_cargo_machinery_framo_st: "/staff-api/list-framo-parameters/",
  view_update_cargo_machinery_framo_st: "/staff-api/view-update-framo-cargo/",
  view_update_auxiliary_machinery_fresh_water:
    "/staff-api/view-update-fresh-water/",
  view_update_auxiliary_machinery_air_conditioning:
    "/staff-api/view-update-air-conditiong/",
  view_update_auxiliary_machinery_refrigeration:
    "/staff-api/view-update-refrigeration/",
  view_update_other_machinery: "/staff-api/view-update-other-machine/",
  add_auxiliary_machinery_refrigeration: "/staff-api/add-refrigeration/",
  add_auxiliary_other_machinery: "/staff-api/add-other-machine/",
  view_update_auxiliary_machinery_fresh_water:
    "/staff-api/view-update-fresh-water/",
  view_update_auxiliary_machinery_air_conditioning:
    "/staff-api/view-update-air-conditiong/",
  view_update_auxiliary_machinery_refrigeration:
    "/staff-api/view-update-refrigeration/",
  view_update_other_machinery: "/staff-api/view-update-other-machine/",
  list_ship_machinary_details_st: "/staff-api/list-ship-machinary-details/",
  add_auxiliary_boiler_info_st: "/staff-api/add-auxiliary-boiler-info/",
  view_update_auxiliary_boiler_st: "/staff-api/view-update-auxiliary-boiler/",
  add_auxiliary_purifier_info_st: "/staff-api/add-auxiliary-purifier-info/",
  view_update_auxiliary_purifier_st:
    "/staff-api/view-update-auxiliary-purifier/",
  add_auxiliary_pump_info_st: "/staff-api/add-auxiliary-pump-info/",
  view_update_auxiliary_pump_st: "/staff-api/view-update-auxiliary-pump/",
  add_auxiliary_compressor_info_st: "/staff-api/add-auxiliary-compressor-info/",
  view_update_auxiliary_compressor_st:
    "/staff-api/view-update-auxiliary-compressor/",
  list_ship_boiler_details_st: "/staff-api/list-ship-boiler-details/",
  list_ship_purifier_details_st: "/staff-api/list-ship-purifier-details/",
  list_ship_pump_details_st: "/staff-api/list-ship-pump-details/",
  list_ship_compressor_details_st: "/staff-api/list-ship-compressor-details/",
  ship_main_details_st: "/staff-api/ship-main-details/",
  ship_auxi_details_st: "/staff-api/ship-auxi-details/",
  edit_ship_view_st: "/staff-api/edit-ship-view/",
  view_ship_details_st: "/staff-api/view-ship-details/",
  ship_crane_details_st: "/staff-api/ship-crane-details/",
  ship_boiler_details_st: "/staff-api/ship-boiler-details/",
  ship_pump_details_st: "/staff-api/ship-pump-details/",
  ship_compressor_details_st: "/staff-api/ship-compressor-details/",
  ship_purifier_details_st: "/staff-api/ship-purifier-details/",
  view_alarm_conditions_st: "/staff-api/view-alarm-conditions/",
  view_eng_comment_st: "/staff-api/view-eng-comment/",
  voyage_status_st: "/staff-api/voyage-status/",
  view_machinary_details_st: "/staff-api/view-machinary-details/",
  list_machinary_details_st: "/staff-api/list-machinary-details/",
  delete_garbage_record_st: "/staff-api/delete-garbage-record/",
  add_orb_details_st: "/staff-api/add-orb-details/",
  view_update_orb_details_st: "/staff-api/view-update-orb-details/",
  list_orb_records_st: "/staff-api/list-orb-records/",
  delete_orb_st: "/staff-api/delete-orb/",
  daily_task_details_st: "/staff-api/view-update-daily-task-report/",
  daily_task_details_report_st: "/staff-api/add-daily-task-report/",
  list_daily_task_report_st: "/staff-api/list-daily-task-report/",
  delete_daily_task_report_st: "/staff-api/delete-daily-task-report/",
  list_daily_task_components_st: "/staff-api/list-daily-task-components/",
  list_code_categories_st: "/staff-api/list-code-categories/",
  list_subdetails_category_st: "/staff-api/list-subdetails-category/",
  orb_part1_form_schema_st: "/staff-api/orb-part1-form-schema/",
  orb_part1_validate_preview_st: "/staff-api/orb-part1-validate-preview/",
  deck_log_audit_logs_st: "/staff-api/deck-log-audit-logs/",
  sounding_log_audit_logs_st: "/staff-api/sounding-log-audit-logs/",
  garbage_log_audit_logs_st: "/staff-api/garbage-log-audit-logs/",
  orb_log_audit_logs_st: "/staff-api/orb-log-audit-logs/",
  daily_task_log_audit_logs_st: "/staff-api/daily-task-log-audit-logs/",
  ship_voyage_audit_logs_st: "/staff-api/ship-voyage-audit-logs/",
  engine_log_basic_audit_logs_st: "/staff-api/engine-log-basic-audit-logs/",
  update_single_checkbox_st: "/staff-api/update-single-checkbox/",
  update_multiple_checkboxes_st: "/staff-api/update-multiple-checkboxes/",
  staff_dashboard_graph: "/staff-api/get-rpm-graph-data/",
  save_as_draft_eng_logbook_st: "/staff-api/save-as-draft-eng-logbook/",
  list_ship_bwts_details_st: "/staff-api/list-bwts-machinery/",
  list_ship_igg_details_st: "/staff-api/list-igg-parameters/",
  list_ship_cargo_crane_details_st: "/staff-api/list-crane-parameters/",
  get_voyage_and_consumption_summary:
    "/staff-api/get-voyage-and-consumption-summary/",
  create_daily_consumption_log: "/staff-api/create-daily-consumption-log/",
  list_daily_consumption_log: "/staff-api/list-daily-consumption-log/",
  list_notifications: "/staff-api/notification-request-list/",
  notification_save_req: "/staff-api/requests-notification/",
  bell_icon_notifiction_list: "/staff-api/notification-list/",
  update_single_checkbox_st_garbage:
    "/staff-api/update-single-checkbox-master/",
  update_multiple_checkboxes_st_garbage:
    "/staff-api/update-multiple-checkboxes-master/",
  list_ballasting_codes_staff: "/staff-api/list-ballasting-codes/",
  list_ballasting_items_staff: "/staff-api/list-ballasting-items/",
  add_ballasting_details_staff: "/staff-api/add-ballasting-details/",
  list_ballasting_records_staff: "/staff-api/list-ballasting-records/",
  view_or_update_ballasting_details_staff:
    "/staff-api/view-or-update-ballasting-details/",
  multiple_checkbox_ballasting_st: "/staff-api/multiple-checkbox-ballasting/",
  single_checkbox_ballasting_st: "/staff-api/single-checkbox-ballasting/",
  requests_notification_grb_st: "/staff-api/requests-notification-grb/",
  ballasting_requests_notification_st:
    "/staff-api/ballasting-requests-notification/",
  remove_file_st: "/staff-api/delete-file-orb/",
  remove_garbage_file_st: "/staff-api/delete-garbage/",
  remove_ballast_file_st: "/staff-api/delete-ballast/",
  bunker_report_list: "/staff-api/bunker-report-list/",
  add_bunker_report: "/staff-api/save-bunker-tank-entry/",
  bunker_tank_entries: "/staff-api/list_bunker_tank_entries/",
  view_bunker_tank_entries: "/staff-api/bunker-view/",
  generate_report_st: "/staff-api/generate-report",
  add_bunker_details_st_bd: "/staff-api/add-sulphur-record-one/",
  list_bunker_details_st_bd: "/staff-api/list-sulphur-records-one/",
  update_bunker_details_st_bd: "/staff-api/view-or-update-sulphur-record-one/",
  add_bunker_delivery_st_bdn: "/staff-api/add-sulphur-record-two/",
  list_bunker_delivery_st_bdn: "/staff-api/list-sulphur-records-two/",
  view_bunker_delivery_st_bdn: "/staff-api/view-or-update-sulphur-record-two/",
  add_bunker_fuel_chargerover_st_fcr: "/staff-api/add-sulphur-record-three/",
  list_bunker_fuel_chargerover_st_fcr: "/staff-api/list-sulphur-records-three/",
  view_bunker_fuel_chargerover_st_fcr:
    "/staff-api/view-or-update-sulphur-record-three/",
  update_staff_security_code_st: "/staff-api/update-staff-security-code/",
  verify_security_code_st: "/staff-api/verify-security-code/",
  ballast_audit_logs_st: "/staff-api/ballast-audit-logs/",
  sulphur_record_bd_st: "/staff-api/sulphur-record-bd/",
  sulphur_record_bdn_st: "/staff-api/sulphur-record-bdn/",
  sulphur_record_fcr_st: "/staff-api/sulphur-record-fcr/",
  bunker_audit_logs_st: "/staff-api/bunker-audit-logs/",
  daily_consumption_audit_logs_st: "/staff-api/daily-consumption-audit-logs/",
  garbage_last_date_st: "/staff-api/garbage-last-date/",
  sulphur_bd_requests_notification_st:
    "/staff-api/sulphur-bd-requests-notification/",
  sulphur_bdn_requests_notification_st:
    "/staff-api/sulphur-bdn-requests-notification/",
  sulphur_fcr_requests_notification_st:
    "/staff-api/sulphur-fcr-requests-notification/",
  add_cargo_remarks_st: "/staff-api/add-cargo-remark/",
  get_cargo_remarks_details_st: "/staff-api/view-update-cargo-remark/",
  add_auxi_remarks: "/staff-api/add-machinary-remark/",
  get_auxi_remarks_details: "/staff-api/view-update-machinary-remark/",
  staff_api_sounding_last_date_st: "/staff-api/sounding-last-date/",
  all_machinary_on_ship_st: "/staff-api/all-machinary-on-ship/",
  staff_api_machine_fields_graph_st: "/staff-api/machine-fields-graph/",
  tanks_level_details_st: "staff-api/bunker-data/",
  basic_previous_date_st: "staff-api/basic-previous-date/",
  list_cargo_codes_st: "/staff-api/list-cargo-codes/",
  get_cargo_item_st: "/staff-api/get-cargo-item/",
  add_cargo_details_st: "/staff-api/add-cargo-details/",
  list_cargo_records_st: "/staff-api/list-cargo-records/",
  view_or_update_cargo_details_st: "/staff-api/view-or-update-cargo-details/",
  delete_cargo_st: "/staff-api/delete-cargo/",
  cargo_requests_notification_st: "/staff-api/cargo-requests-notification/",
  delete_ballast_record_st: "/staff-api/delete-ballast-record/",
  remove_cargo_file_st: "/staff-api/remove-cargo-file/",
  staff_api_cargo_audit_logs_st: "/staff-api/cargo-audit-logs/",
  staff_modules_st: "/staff-api/staff-modules/",
  staff_dashboard_info_st: "/staff-api/staff-dashboard-info/",
  pending_entry_list_st: "/staff-api/pending-entry-list/",
  get_tank_rob_graph_data_st: "/staff-api/get-tank-rob-graph-data/",
  bug_severity_options_st: "/staff-api/severity-options/",
  bug_report_st: "/staff-api/bug-report/",
  change_request_st: "/staff-api/change-request/",
  priority_options_st: "/staff-api/priority-options/",
  feature_request_st: "/staff-api/feature-request/",
  feedback_st: "/staff-api/feedback/",
  ods_equipment: "/staff-api/list-of-equip-add/",
  ods_refrigerant_log: "/staff-api/supply-and-discharge-add/",
  ods_record: "/staff-api/refrigeration-equipment-add/",
  ods_system_types: "/staff-api/ods-system-types/",
  ods_listing_details: "/staff-api/ods-listing-details/",
  list_ods_record: "/staff-api/ods-listing/",
  ods_refrigerant_log_update: "/staff-api/supply-and-discharge-update/",
  ods_record_update: "/staff-api/refrigeration-equipment-update/",
  ods_equipment_update: "/staff-api/list-of-equip-update/",
  ods_equipment_get: "/staff-api/list-of-equip-get/",
  ods_refrigerant_log_get: "/staff-api/supply-and-discharge-get/",
  ods_record_get: "/staff-api/refrigeration-equipment-get/",
  supply_and_discharge: "/staff-api/supply-and-discharge/",
  refrigeration_equipment_log: "/staff-api/refrigeration-equipment-log/",
  add_refrigeration_ods_notification:
    "/staff-api/add-refrigeration-ods-notification/",
  staff_register: "staff-api/staff-registration/",
  add_log: "staff-api/log/add/",
  list_ship_staff_audit_logs: "staff-api/list-ship-staff/audit-logs/",
  staff_view_registered_staff: "staff-api/staff-view-registered-staff/",
  staff_edit_registered_staff: "staff-api/staff-edit-registered-staff/",
  staff_delete_registered_staff: "staff-api/staff-delete-registered-staff/",
  download_rest_hours_pdf_staff:
    "/resthours/staff-api/rest-hours/download-pdf/",

  // Rest Hours — company view (MLC 2006 / STCW compliance)
  list_rest_hours_log_com: "resthours/company-api/log/list/",
  view_rest_hours_record_com: "resthours/company-api/record/view/",
  rest_hours_dashboard_com: "resthours/company-api/dashboard/",
  download_rest_hours_pdf_com:
    "/resthours/company-api/rest-hours/download-pdf/",
  // Violations — company
  violations_fleet_com: "resthours/company-api/violations/fleet/",
  violations_unresolved_com: "resthours/company-api/violations/unresolved/",
  violations_history_com: "resthours/company-api/violations/history/",

  // Rest Hours (MLC 2006 / STCW compliance)
  add_rest_hours_st: "resthours/staff-api/log/add/",
  edit_log_rest_hours_st: "resthours/staff-api/log/edit/",
  list_rest_hours_st: "resthours/staff-api/log/list/",
  view_or_update_rest_hours_st: "resthours/staff-api/log/edit/",
  delete_rest_hours_st: "resthours/staff-api/log/delete/",
  rest_hours_audit_logs_st: "resthours/staff-api/rest-hours-audit-logs/",
  rest_hours_requests_notification_st:
    "resthours/staff-api/rest-hours-requests-notification/",
  view_rest_hours_record_st: "resthours/staff-api/record/view/",
  rest_hours_dashboard_st: "resthours/staff-api/dashboard/",
  // Violations — staff
  violations_active_st: "resthours/staff-api/violations/active/",
  violations_interval_st: "resthours/staff-api/violations/interval/",
  violations_acknowledge_st: "resthours/staff-api/violations/acknowledge/",
  violations_resolved_st: "resthours/staff-api/violations/resolved/",
  violations_history_st: "resthours/staff-api/violations/history/",
  compliance_rules_st: "resthours/staff-api/rules/",
  update_compliance_rule_st: "resthours/staff-api/rules/update/",
  compliance_rule_history_st: "resthours/staff-api/rules/history/",

  //*********************************** Company ****************************************** //

  add_ship: "/company-api/add-ship/",
  list_ships_view_com: "/company-api/list-ships-view/",
  dashboard_ship_details_com: "/company-api/dashboard-ship-details/",
  delete_ship: "/company-api/delete-ship/",
  ship_status: "/company-api/staff-status-ship/",
  staff_registration: "/company-api/staff-registration/",
  view_registered_staff: "/company-api/view-registered-staff/",
  edit_registered_staff: "/company-api/edit-registered-staff/",
  ship_staff_status: "/company-api/ship-staff-status/",
  staff_soft_delete: "/company-api/delete-staff/",
  list_register_staff: "/company-api/list-ship-staff/",
  list_role_permission: "/company-api/list-role-permission/",
  view_voyage_info_com: "/company-api/view-voyage-info/",
  list_voyage_info_com: "/company-api/list-voyage-info/",
  ship_main_details_com: "/company-api/ship-main-details/",
  ship_auxi_details_com: "/company-api/ship-auxi-details/",
  list_pump_details_com: "/company-api/list-pump-details/",
  list_boiler_details_com: "/company-api/list-boiler-details/",
  list_compressor_details_com: "/company-api/list-compressor-details/",
  list_purifier_details_com: "/company-api/list-purifier-details/",
  edit_ship_view_com: "/company-api/edit-ship-view/",
  view_ship_details_com: "/company-api/view-ship-details/",
  ship_crane_details_com: "/company-api/ship-crane-details/",
  ship_boiler_details_com: "/company-api/ship-boiler-details/",
  ship_pump_details_com: "/company-api/ship-pump-details/",
  ship_compressor_details_com: "/company-api/ship-compressor-details/",
  ship_purifier_details_com: "/company-api/ship-purifier-details/",
  add_machinary_details_com: "/company-api/add-machinary-details/",
  add_boiler_details_com: "/company-api/add-boiler-details/",
  add_pump_details_com: "/company-api/add-pump-details/",
  add_compressor_details_com: "/company-api/add-compressor-details/",
  add_purifier_details_com: "/company-api/add-purifier-details/",
  add_alarm_conditions_com: "/company-api/add-or-update-alarm-conditions/",
  view_alarm_conditions_com: "/company-api/view-alarm-conditions/",
  edit_view_machinary_com: "/company-api/edit-view-machinary/",
  listing_engine_logbook_com: "/company-api/listing-engine-logbook/",
  view_eng_log_basic_com: "/company-api/view-eng-log-basic/",
  view_main_eng_log_com: "/company-api/view-main-eng-log/",
  view_eng_logbook_com: "/company-api/view-eng-logbook/",
  view_auxiliary_eng_log_com: "/company-api/view-auxiliary-eng-log/",
  view_auxiliary_machinery_eng_log_com:
    "/company-api/view-auxiliary-machinery-eng-log/",
  list_ship_machinary_details_com: "/company-api/list-ship-machinary-details/",
  list_ship_boiler_details_com: "/company-api/list-ship-boiler-details/",
  vie_auxiliary_boiler_info_com: "/company-api/view-auxiliary-boiler-info/",
  list_ship_purifier_details_com: "/company-api/list-ship-purifier-details/",
  view_auxiliary_purifier_info_com:
    "/company-api/view-auxiliary-purifier-info/",
  list_ship_pump_details_com: "/company-api/list-ship-pump-details/",
  list_ship_compressor_details_com:
    "/company-api/list-ship-compressor-details/",
  view_auxiliary_compressor_info_com:
    "/company-api/view-auxiliary-compressor-info/",
  view_eng_comment_com: "/company-api/view-eng-comment/",
  view_auxiliary_pump_info_com: "/company-api/view-auxiliary-pump-info/",
  list_tank_categories_com: "/company-api/list-tank-categories/",
  create_tank_com: "/company-api/create-tank/",
  update_tank_details_com: "/company-api/update-tank-details/",
  list_tanks_ship_com: "/company-api/list-tanks-ship/",
  add_fuel_oil_tank_com: "/company-api/add-fuel-oil-tank/",
  view_update_fuel_oil_tank_com: "/company-api/view-update-fuel-oil-tank/",
  add_lube_oil_tank_com: "/company-api/add-lube-oil-tank/",
  view_update_lube_oil_tank_com: "/company-api/view-update-lube-oil-tank/",
  add_bilge_tank_com: "/company-api/add-bilge-tank/",
  create_ows_running_data_com: "/company-api/create-ows-running-data/",
  view_update_bilge_tank_com: "/company-api/view-update-bilge-tank/",
  add_sludge_tank_com: "/company-api/add-sludge-tank/",
  create_incinerator_running_data_com:
    "/company-api/create-incinerator-running-data/",
  view_update_sludge_tank_com: "/company-api/view-update-sludge-tank/",
  add_fresh_water_tank_com: "/company-api/add-fresh-water-tank/",
  view_update_fresh_water_tank_com:
    "/company-api/view-update-fresh-water-tank/",
  list_tanks_com: "/company-api/list-tanks/",
  orb_configuration_com: "/company-api/orb-configuration/",
  list_deck_logs_com: "/company-api/list-deck-logs/",
  view_deck_log_com: "/company-api/view-deck-log/",
  list_sound_log_books_com: "/company-api/list-sound-log-books/",
  list_tank_sound_log_book_com: "/company-api/list-tank-sound-log-book/",
  list_machinary_details_com: "/company-api/list-machinary-details/",
  company_ship_audit_trail: "/company-api/list-ship-audit-logs/",
  company_staff_audit_trail: "/company-api/list-ship-staff-audit-logs/",
  company_listin_garbage_records: "/company-api/listing-garbage-records/",
  company_listing_orb_records: "/company-api/listing-orb-records/",
  company_listing_daily_task_report: "/company-api/listing-daily-task-report/",
  company_single_garbage_record: "/company-api/listing-single-garbage-record/",
  company_single_orb_record: "/company-api/listing-single-orb-record/",
  company_single_daily_task_report:
    "/company-api/listing-single-daily-task-report/",
  list_ship_voyage_audit_logs_com: "/company-api/list-ship-voyage-audit-logs/",
  engine_log_basic_audit_log_com: "/company-api/engine-log-basic-audit-log/",
  deck_log_audit_log_com: "/company-api/deck-log-audit-log/",
  sounding_log_audit_log_com: "/company-api/sounding-log-audit-log/",
  garbage_log_audit_log_com: "/company-api/garbage-log-audit-log/",
  orb_log_audit_log_com: "/company-api/orb-log-audit-log/",
  dailytask_log_audit_log_com: "/company-api/dailytask-log-audit-log/",
  list_code_categories_com: "/company-api/list-code-categories/",
  list_subdetails_category_com: "/company-api/list-subdetails-category/",
  company_get_grap_data_com: "/company-api/get-graph-data/",
  cii_calculated_details_com: "/company-api/cii-calculated-details/",
  duplicate_ship_com: "/company-api/duplicate-ship/",
  add_bwts_details: "/company-api/add-cargo-machinery/",
  update_bwts_details: "/company-api/edit-view-cargo-machinery/",
  view_bwts_details: "/company-api/edit-view-cargo-machinery/",
  list_bwts_details: "/company-api/list-cargo-machinery/",
  list_igg_details_com: "/company-api/list-igg-parameters/",
  add_igg_details_com: "/company-api/add-igg-parameters/",
  ship_igg_details_com: "/company-api/edit-view-igg-parameters/",
  add_cargo_crane_details_com: "/company-api/add-crane-parameters/",
  view_cargo_crane_details_com: "/company-api/edit-view-crane-parameters/",
  list_cargo_crane_details_com: "/company-api/list-crane-parameters/",
  list_lpg_cargo_compressor_details: "/company-api/list-lpg-cargo-parameters/",
  add_lpg_cargo_compressor_details: "/company-api/add-lpg-cargo-parameters/",
  edit_view_lpg_cargo_compressor_details:
    "/company-api/edit-view-lpg-cargo-parameters/",
  list_lng_cargo_compressor_details: "/company-api/list-lng-cargo-parameters/",
  add_lng_cargo_compressor_details: "/company-api/add-lng-cargo-parameters/",
  edit_view_lng_cargo_compressor_details:
    "/company-api/edit-view-lng-cargo-parameters/",
  list_nitrogen_plant_details: "/company-api/list-nitrogen-plant-parameters/",
  add_nitrogen_plant_details: "/company-api/add-nitrogen-plant-parameters/",
  edit_view_nitrogen_plant_details:
    "/company-api/edit-view-nitrogen-plant-parameters/",
  list_copt_details: "/company-api/list-copt-parameters/",
  add_copt_details: "/company-api/add-copt-parameters/",
  update_copt_details: "/company-api/edit-view-copt-parameters/",
  view_copt_details: "/company-api/edit-view-copt-parameters/",
  list_framo_details: "/company-api/list-framo-parameters/",
  add_framo_details: "/company-api/add-framo-parameters/",
  update_view_framo_details: "/company-api/edit-view-framo-parameters/",
  view_fresh_water_into_list_com: "/company-api/view-fresh-water-info/",
  view_update_fresh_water_into_list_com: "/company-api/view-fresh-water-info/",
  view_update_Air_info_com: "/company-api/view-air-conditioning-info/",
  view_Refrigeration_info_com: "/company-api/view-refrigeration-info/",
  view_Other_plan_info_com: "/company-api/view-other-machine-info/",
  list_cargo_bwts_machinery_com: "/company-api/list-cargo-machinery/",
  edit_view_cargo_bwt_machinery_com: "/company-api/view-bwt-cargo-info/",
  edit_view_cargo_igg_machinery_com: "/company-api/view-cargo-igg-info/",
  list_cargo_igg_machinery_com: "/company-api/list-igg-parameters/",
  list_crane_parameters_com: "/company-api/list-crane-parameters/",
  edit_view_carne_info_machinery_com: "/company-api/view-crane-cargo-info/",
  list_lpg_info_machinery_com: "/company-api/list-lpg-cargo-parameters/",
  edit_view_lpg_info_machinery_com: "/company-api/view-lpg-cargo-info/",
  list_lng_info_machinery_com: "/company-api/list-lng-cargo-parameters/",
  edit_view_lng_info_machinery_com: "/company-api/view-lng-cargo-info/",
  list_nitrogen_info_machinery_com:
    "/company-api/list-nitrogen-plant-parameters/",
  edit_view_nitrogen_info_machinery_com:
    "/company-api/view-nitrogen-plant-info/",
  list_copt_info_machinery_com: "/company-api/list-copt-parameters/",
  edit_view_copt_info_machinery_com: "/company-api/view-copt-cargo-info/",
  list_framo_info_machinery_com: "/company-api/list-framo-parameters/",
  edit_view_framo_info_machinery_com: "/company-api/view-framo-cargo-info/",
  view_auxiliary_boiler_info_com: "/company-api/view-auxiliary-boiler-info/",
  view_update_company_info: "/company-api/view-update-company-info/",
  list_daily_consumption_logs: "company-api/list-daily-consumption-logs/",
  listing_ballasting_records_com: "/company-api/listing-ballasting-records/",
  view_ballasting_record_com: "/company-api/view-ballasting-record/",
  list_operation_codes_com: "/company-api/list-operation-codes/",
  list_operation_items_com: "/company-api/list-operation-items/",
  generate_report_com: "/company-api/generate-report",
  list_bunker_report_com: "/company-api/list-bunker-tank-entries/",
  view_bunker_report_com: "/company-api/bunker-view/",
  list_bunker_details_bd_com: "/company-api/list-sulphur-record-one/",
  view_bunker_details_bd_com: "/company-api/view-sulphur-record-one/",
  list_bunker_delivery_bdn_com: "/company-api/list-sulphur-record-two/",
  view_bunker_delivery_bdn_com: "/company-api/view-sulphur-record-two/",
  list_bunker_fuel_chargerover_fcr_com:
    "/company-api/list-sulphur-record-three/",
  view_bunker_fuel_chargerover_fcr_com:
    "/company-api/view-sulphur-record-three/",
  ballasting_log_audit_log_com: "/company-api/ballasting-log-audit-log/",
  daily_consumption_audit_log_com: "/company-api/daily-consumption-audit-log/",
  bunker_tank_audit_log_com: "/company-api/bunker-tank-audit-log/",
  sulphur_record_bd_log_com: "/company-api/sulphur-record-bd-log/",
  sulphur_record_bdn_log_com: "/company-api/sulphur-record-bdn-log/",
  sulphur_record_fcr_log_com: "/company-api/sulphur-record-fcr-log/",
  all_machinary_on_ship_com: "/company-api/all-machinary-on-ship/",
  machine_fields_graph_com: "/company-api/machine-fields-graph/",
  company_modules_com: "/company-api/compnay-modules/",
  company_start_trial: "/company-api/subscription/start-trial/",
  listing_cargo_records_com: "/company-api/listing-cargo-records/",
  single_cargo_record_com: "/company-api/view-cargo-record/",
  cargo_audit_logs_com: "/company-api/cargo-audit-log/",
  list_cargo_codes_com: "/company-api/list-cargo-codes/",
  get_cargo_item_com: "/company-api/get-cargo-item/",
  all_machinary_on_multiple_ship_com:
    "/company-api/all-machinary-on-multiple-ships/",
  multiple_machine_fields_graph_com: "/company-api/machine-fields-graph-multi/",
  multiple_company_get_grap_data_com: "/company-api/get-graph-data-multi/",
  bug_severity_options_com: "/company-api/severity-options/",
  bug_report_com: "/company-api/bug-report/",
  change_request_com: "/company-api/change-request/",
  priority_options_com: "/company-api/priority-options/",
  feature_request_com: "/company-api/feature-request/",
  feedback_com: "/company-api/feedback/",
  company_bug_report_list_com: "/company-api/bug-report-list/",
  company_change_request_list_com: "/company-api/change-request-list/",
  feature_request_list_com: "/company-api/feature-request-list/",
  feedback_list_com: "/company-api/feedback-list/",
  all_issues_com: "/company-api/all-issues/",
  list_office_staff: "/company-api/list-office-staff/",
  company_staff_registration: "/company-api/office-staff-registration/",
  list_office_roles: "/company-api/list-office-roles/",
  get_company_office_staff: "/company-api/get-company-office-staff/",
  edit_company_office_staff: "/company-api/edit-company-office-staff/",
  delete_office_staff: "/company-api/delete-office-staff/",
  add_machinery: "/pms-api/add-machinery",
  update_machinery: "/pms-api/update-machinery",
  view_machinery: "/pms-api/view-machinery",
  list_machinery: "/pms-api/list-machinery",
  add_equipment: "/pms-api/add-equipment",
  list_equipment: "/pms-api/list-equipment",
  view_equipment: "/pms-api/view-equipment",
  update_equipment: "/pms-api/update-equipment",
  delete_equipment: "/pms-api/delete-equipment",
  ship_machinery_list: "/pms-api/ship-machinery-list",
  function_hierarchy: "/pms-api/function-hierarchy",
  list_job_tasks: "/pms-api/list-job-tasks",
  view_job_task: "/pms-api/view-job-task",
  update_job_task_status: "/pms-api/update-job-task-status",
  add_job: "/pms-api/add-job",
  list_job: "/pms-api/list-jobs",
  view_job: "/pms-api/view-job",
  delete_job: "/pms-api/delete-job",
  edit_job: "/pms-api/edit-job",
  list_work_orders: "/pms-api/list-work-orders",
  complete_work_order: "/pms-api/complete-work-order",
  view_completed_work_order: "/pms-api/view-completed-work-order",
  staff_list_work_orders: "staff-api/staff-list-work-orders/",
  staff_view_completed_work_order: "staff-api/staff-view-completed-work-order/",
  staff_list_job: "staff-api/staff-list-jobs/",
  staff_complete_work_order: "staff-api/staff-complete-work-order/",
  staff_list_role_permission: "staff-api/staff-list-role-permission/",
  staff_function_hierarchy: "staff-api/staff-functional-hierarchy/",
  staff_view_machinery: "staff-api/staff-view-machinery/",
  staff_ship_machinery_list: "staff-api/staff-ship-machinery-list/",
  staff_add_machinery: "staff-api/staff-add-machinery/",
  staff_update_machinery: "staff-api/staff-update-machinery/",
  staff_add_job: "staff-api/staff-add-job/",
  staff_delete_job: "staff-api/staff-delete-job/",
  staff_edit_job: "staff-api/staff-edit-job/",
  staff_view_job: "staff-api/staff-view-job/",
  staff_list_work_orders: "staff-api/staff-list-work-orders/",
  list_company_staff: "staff-api/list-ship-staff/",

  // ODS Records
  company_list_ods_record: "/company-api/company-ods-listing/",
  company_view_ods_record: "/company-api/company-list-of-equip-get/",
  company_supply_and_discharge: "/company-api/company-supply-and-discharge/",
  company_supply_and_discharge_get:
    "/company-api/company-supply-and-discharge-get/",
  company_refrigeration_equipment_log:
    "/company-api/company-refrigeration-equipment-log/",
  company_refrigeration_equipment_get:
    "/company-api/company-refrigeration-equipment-get/",

  //*********************************** ChatBot ****************************************** //
  staff_chatbot: "/staff-api/chatbot/",
  company_chatbot: "/company-api/chatbot/",
  list_inspection_zones: "/company-api/list-inspection-zones/",
  add_photographic_analysis: "/company-api/create-inspection/",
  list_inspections: "/company-api/list-inspections/",
};

//*********************************** Dwonload Pdf Url ****************************************** //

export const enginglogdownloadPdfUrl = "staff-api/generate-engine-log-pdf";
export const decklogdownloadPdfUrl = "staff-api/generate-deck-log-pdf";
export const soundinglogdownloadPdfUrl = "staff-api/generate-sounding-log-pdf";
export const oilpartonelogdownloadPdfUrl = "staff-api/generate-oil1-record-pdf";
export const oilparttwologdownloadPdfUrl = "staff-api/generate-oil2-record-pdf";
export const dailytasklogdownloadPdfUrl = "staff-api/generate-daily-task-pdf";
export const dailyconsumptionPdfUrl =
  "staff-api/export-daily-consumption-log-csv";
export const ballastrecordPdfUrl = "staff-api/generate-ballast-log-pdf";
export const garbagelogdownloadPdfUrl = "staff-api/generate-garbage-log-pdf";
export const garbagelogdownloadPdfUrltwo =
  "staff-api/generate-garbage2-log-pdf";
export const bunkerpdfdownloadUrl = "staff-api/generate-bunker-log-pdf";
export const generatesulphurbd = "staff-api/generate-sulphur-bd-pdf";
export const generatesulphurbdn = "staff-api/generate-sulphur-bdn-pdf";
export const generatesulphurfcr = "staff-api/generate-sulphur-fcr-pdf";
export const generatecargopdf = "staff-api/generate-cargo-log-pdf";

export const odsEquipmentPdfUrl = "staff-api/generate-ods-equipment-pdf";
export const odsRefrigerantPdfUrl =
  "staff-api/generate-supply-and-discharge-pdf";
export const odsRecordPdfUrl =
  "staff-api/generate-refrigeration-equipment-log-pdf";
export const restHoursPdfUrl = "staff-api/generate-rest-hours-pdf";

export const S3_BASE_URL = "https://marin-dev.s3.amazonaws.com/";
